export const customSort = (sortBy, sortOrder, rows) => {
    var itemsToSort = rows;
    var sortedItems = [];
    var compareFn = null;
    switch (sortBy) {
        case "name":
            compareFn = (i, j) => {
                if (i.name < j.name) {
                    return sortOrder === "asc" ? -1 : 1;
                } else {
                    if (i.name > j.name) {
                        return sortOrder === "asc" ? 1 : -1;
                    } else {
                        return 0;
                    }
                }
            };
            break;
        case "pincode":
            compareFn = (i, j) => {
                if (i.code < j.code) {
                    return sortOrder === "asc" ? -1 : 1;
                } else {
                    if (i.code > j.code) {
                        return sortOrder === "asc" ? 1 : -1;
                    } else {
                        return 0;
                    }
                }
            };
            break;
        default:
            compareFn = (i, j) => {
                if (i[sortBy] < j[sortBy]) {
                    return sortOrder === "asc" ? -1 : 1;
                } else {
                    if (i[sortBy] > j[sortBy]) {
                        return sortOrder === "asc" ? 1 : -1;
                    } else {
                        return 0;
                    }
                }
            };
            break;
    }

    sortedItems = itemsToSort.sort(compareFn);
    return sortedItems;
};

export const descendingComparator = (a, b, orderBy) => {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
};

export const getComparator = (order, orderBy) => {
    return order === 'desc' ? (a, b) => descendingComparator(a, b, orderBy) : (a, b) => -descendingComparator(a, b, orderBy);
};

export const stableSort = (array, comparator) => {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) {
            return order;
        }
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}